import { useEffect, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import {
  clearParentDomainCookie,
  isSpanishSelected,
  ensureGoogleTranslateLoaded,
  changeLanguage,
} from '@/lib/utils/googleTranslate'

function getInitialLanguage() {
  if (typeof window === 'undefined') {
    return 'en'
  }
  return isSpanishSelected() ? 'es' : 'en'
}

export function LanguageSelector() {
  const [selectedLanguage, setSelectedLanguage] = useState(getInitialLanguage)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    clearParentDomainCookie()

    if (selectedLanguage === 'es') {
      ensureGoogleTranslateLoaded(function () {})
    }
  }, [selectedLanguage])

  const onLanguageChange = (language: string) => {
    setSelectedLanguage(language)
    changeLanguage(language)
  }

  return (
    <div className="translate-widget fixed bottom-4 right-[60px] z-50 flex items-center sm:right-[80px]">
      <img src="/language-widget-icon.png" alt="" className="translate-widget-logo" aria-hidden="true" />
      <label htmlFor="languageSwitcher" className="sr-only">
        Select language
      </label>
      <span className="translate-widget-select-wrap">
        <select
          id="languageSwitcher"
          value={selectedLanguage}
          onChange={(event) => onLanguageChange(event.target.value)}
        >
          <option value="en">English</option>
          <option value="es">Spanish</option>
        </select>
        <span className="translate-widget-chevron" aria-hidden="true">
          <ChevronDown size={16} strokeWidth={2.5} />
        </span>
      </span>
      <div id="google_translate_element" aria-hidden="true"></div>
    </div>
  )
}
